import request from '@/utils/request'

// 分页查询店铺列表
export function getShopPage(data) {
    return request({
        url: '/admin/shop/page',
        method: 'post',
        data: data
    })
}

// 获取店铺详情
export function getShopDetail(id) {
    return request({
        url: '/admin/shop/detail?id=' + id,
        method: 'get'
    })
}

// 新增店铺
export function insertShop(data) {
    return request({
        url: '/admin/shop/insert',
        method: 'post',
        data: data
    })
}

// 修改店铺
export function updateShop(data) {
    return request({
        url: '/admin/shop/update',
        method: 'post',
        data: data
    })
}

// 删除店铺
export function deleteShop(id) {
    return request({
        url: '/admin/shop/delete?id=' + id,
        method: 'get'
    })
}

// 获取所有启用的店铺列表
export function listEnabledShops() {
    return request({
        url: '/admin/shop/listEnabled',
        method: 'get'
    })
}
